import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AppErrorBoundary from "../components/AppErrorBoundary";
import DisclaimerBanner from "../components/DisclaimerBanner";

export default function SiteLayout() {
  return (
    <>
      <Header />
      <DisclaimerBanner />
      <AppErrorBoundary>
        <Outlet />
      </AppErrorBoundary>
      <Footer />
    </>
  );
}
